import { createAction, props } from '@ngrx/store';
import { Order } from 'src/objects/order';

export const resetTimeout = createAction(
  '[Order] Reset Timeout',
  props<{order: Order}>(),
);

export const resetTimeoutSuccess = createAction(
  '[Order] Reset Timeout Success',
  props<{order: Order}>(),
);

export const resetTimeoutFailure = createAction(
  '[Order] Reset Timeout Failure',
  props<{order: Order; error: Error}>(),
);

export const timeoutWarning = createAction(
  '[Order] Session Timeout Warning',
  props<{order: Order}>(),
);

export const timeoutError = createAction(
  '[Order] Session Timeout Error',
  props<{order: Order}>(),
);

export const updateTimeout = createAction(
  '[Order] Update Timeout',
  props<{order: Order; timeout: number}>(),
);
